import Tip from './tips'

export default Tip


// WEBPACK FOOTER //
// ./src/components/base/tip/index.js